import Vue from 'vue'
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify)

export default new Vuetify({
    theme: {
        themes: {
            light: {
                primary: '#55D6BE',
            },
            dark: {
                primary: '#55D6BE',
            },
        },
        options: {
            customProperties: true,
        },
    },
})

//https://colors.muz.li/palette/1f306e/553772/8f3b76/c7417b/f5487f
